export default "__VITE_ASSET__cdafcdf5__"